/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OverduePaymentResource
 */
export interface OverduePaymentResource extends ProjectDeliverablePaymentResource {
}

/**
 * Check if a given object implements the OverduePaymentResource interface.
 */
export function instanceOfOverduePaymentResource(value: object): value is OverduePaymentResource {
    return true;
}

export function OverduePaymentResourceFromJSON(json: any): OverduePaymentResource {
    return OverduePaymentResourceFromJSONTyped(json, false);
}

export function OverduePaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverduePaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function OverduePaymentResourceToJSON(value?: OverduePaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
    };
}

